/**
 * How a payment is initiated — shared by both payins and payouts, since both rails resolve to
 * the same two mechanisms: a provider-initiated transfer (PIS/RTP, chosen globally via config)
 * or a manual bank transfer tracked by reference code.
 */
export enum PaymentMethod {
  PIS = 'pis',
  MANUAL = 'manual_transfer'
}
